import { render } from "./sort-block.vue?vue&type=template&id=660fe53a&ts=true"
import script from "./sort-block.vue?vue&type=script&lang=ts"
export * from "./sort-block.vue?vue&type=script&lang=ts"

import "./sort-block.vue?vue&type=style&index=0&id=660fe53a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__